//#region Disabler
var disabler = {
    events: {
        disabler: 'disabler',
        ended: 'disabler-ended'
    },
    triggerEvent($items, event) {
        $items && $items.each((i, e) => {
            $(e).trigger({
                type: event
            })
        })
    },
    changeVisibility($element, isToShow, callback) {
        if ($element.hasClass('hiddable-dt')) {
            let $itemToHide = $element.closest('tr, .item-to-hide')

            if (isToShow) {
                $itemToHide.fadeIn(150, callback)
            }
            else if ($element.data('isHiddableInitied') === true) {
                $itemToHide.fadeOut(150, callback)
            } else {
                $element.data('isHiddableInitied', true)
                $itemToHide.hide()
                callback && callback()
            }
        }
        else {
            callback && callback()
        }
    },
    manageTooltip($items) {
        $items.each((i, e) => {
            let $item = $(e)

            if ($item.hasClass('tooltip-if-disabled')) {
                let $tooltipParent;

                if ($item.closest('.custom-checkbox').length > 0) {
                    $tooltipParent = $item.closest('.custom-checkbox')
                } else if ($item.hasClass('kdr-dropdown-w-search-item_selected')) {
                    $tooltipParent = $item.closest('.kdr-dropdown-tooltip')
                }

                if ($item.attr('disabled') == 'disabled') {
                    $tooltipParent.tooltip({
                        delay: {
                            show: tooltipOtions.delay.show,
                            hide: tooltipOtions.delay.hide
                        },
                        boundary: tooltipOtions.boundary,
                        trigger: tooltipOtions.trigger
                    })
                }
                else {
                    $tooltipParent.tooltip('dispose')
                }
            }
        })
    },
    checkChildren($items) {
        $items.filter((i, e) => $(e).prop('class').includes('ds')).trigger('disabler')
    },
    disableBasedOnCheckbox($cb, triggerEvent = true) {
        let cbMasterState = $cb.is(":checked")
        let dsPattern = /ds-(\S+)/i

        let groupIndex = $cb.attr('class').match(dsPattern)[1]
        let $targets = $('[class*="dt-' + groupIndex + '"]')

        for (var i = 0; i < $targets.length; i++) {
            let $t = $targets.eq(i)
            let stateToSet;

            let andGroups = $t.attr('class').match(/dt-([^-(m+)ddl]\S*)/ig)
            let orGroups = $t.attr('class').match(/(?:dt\-([A-Za-z0-9\-]+)(?=\/)|\/dt\-([A-Za-z0-9\-]+))/ig)
            let ddlGroups = $t.attr('class').match(/dt-ddl-(\S+)/ig)
            let orIds = []

            if (isNullOrUndefined(andGroups)) andGroups = [];
            if (isNullOrUndefined(orGroups)) orGroups = [];
            if (isNullOrUndefined(ddlGroups)) ddlGroups = [];


            if (orGroups != null && orGroups.length > 0) {
                $(orGroups).each((i, e) => {
                    let m = $(e.match(/dt-(\S+)[^\/]?/i)).last()
                    if (m != undefined && m != null) {
                        orIds.push(m[0])
                    }
                })
            }


            if (andGroups.length > 0 && cbMasterState && orIds.length == 0) {//'and' mode
                let isAllChecked = true
                $(andGroups).each(function () {
                    let index = this.match(/dt-(\S+)/i)[1]
                    if (!$('.ds-' + index).is(':checked')) {
                        isAllChecked = false
                        return false
                    }
                })
                stateToSet = isAllChecked
            }
            else if (orIds.length > 0) { //'or' mode
                $(orIds).each(function () {
                    let isChecked = $('.ds-' + this + '').is(':checked')
                    if (isChecked) {
                        stateToSet = true
                        return false
                    }
                })
            }
            else {
                stateToSet = cbMasterState
            }


            if (stateToSet) {
                $t.removeAttr('disabled')
            } else {
                $t.attr('disabled', 'disabled')

                if ($t.hasClass('kdr-dropdown-w-search-item_selected') == true && $t.closest('.kdr-dropdown-w-search_multi').length > 0) {
                    kdrDropdown.clearDropdown($t.parent())
                } else {
                    $t.valExtended('')
                }
            }


            if (ddlGroups != null && ddlGroups.length > 0 && cbMasterState === true) {
                $(ddlGroups).each((x, i) => {
                    $('.' + i.replace('dt', 'ds')).trigger('disabler')
                })
            } else {
                disabler.changeVisibility($t, stateToSet)

                $t.each((x, i) => {
                    let $i = $(i)
                    if ($i.closest('.kdr-dropdown-w-search').length > 0) {
                        $i.trigger('disabler')
                    }
                })

            }

            disabler.checkChildren($targets)
            disabler.manageTooltip($t)
            if (triggerEvent) {
                disabler.triggerEvent($t, disabler.events.ended)
            }
        }
    },
    disableBasedOnDDL($ddl, triggerEvent = true) {
        let dsPattern = /ds-ddl-(\S+)/i

        let groupKey = $ddl.attr('class').match(dsPattern)[1]

        let $targets = $('[class*="dt-ddl-' + groupKey + '"]')

        let isEnablerSelected = false

        for (var i = 0; i < $targets.length; i++) {
            let $t = $targets.eq(i)
            let allGroups = $t.attr('class').match(/(dt-ddl-[^\/]\S*)/ig) ?? [] //powinny byc pewnie tez inne kontrolki

            let orGroups = []
            let andGroups = []

            for (var j = 0; j < allGroups.length; j++) {
                if (allGroups[j].includes('/')) {
                    orGroups.push(allGroups[j])
                } else {
                    andGroups.push(allGroups[j])
                }
            }

            let isEveryOrGroupConditionMet = false
            let isAndGroupConditionMet = true

            if (orGroups.length > 0) {
                let orGroupsConditionMet = 0
                for (var j = 0; j < orGroups.length; j++) {
                    let og = orGroups[j].split('/')
                    let isGActivated = false

                    for (var k = 0; k < og.length; k++) {
                        if (isGActivated == true) {
                            break
                        }

                        let gIndex = og[k].match(/dt-ddl-(\S+)/i)[1]
                        let $gDDL = $('.ds-ddl-' + gIndex)


                        if (($gDDL[0].hasAttribute('disabled') && ($gDDL.attr('disabled') == 'disabled' || $gDDL.attr('disabled') == 'true'))) {
                            //dana ddl jest wylaczone, wiec mozemy sprawdzic kolejna
                            continue;
                        } else {
                            let $sDDLSelectedIndices = $gDDL.valExtended()
                            let $menu = kdrDropdown.getTogglerMenu($gDDL)

                            if ($.isArray($sDDLSelectedIndices)) {

                                for (var l = 0; l < $sDDLSelectedIndices.length; l++) {
                                    isGActivated = $menu.find(`.kdr-dropdown-w-search-item[data-value="${$sDDLSelectedIndices[l]}"] [class*="da-ddl-${gIndex}"]`).length > 0

                                    if (isGActivated == true) break;
                                }
                            } else {
                                isGActivated = $menu.find(`.kdr-dropdown-w-search-item[data-value="${$sDDLSelectedIndices}"] [class*="da-ddl-${gIndex}"]`).length > 0
                            }
                        }
                    }

                    if (isGActivated == true) {
                        orGroupsConditionMet++
                    }
                }

                isEveryOrGroupConditionMet = orGroups.length == orGroupsConditionMet
            } else {
                isEveryOrGroupConditionMet = true
            }

            if (andGroups.length > 0) {
                for (var j = 0; j < andGroups.length; j++) {
                    let gIndex = andGroups[j].match(/dt-ddl-(\S+)/i)[1]
                    let $gDDL = $('.ds-ddl-' + gIndex)

                    if (($gDDL[0].hasAttribute('disabled') && ($gDDL.attr('disabled') == 'disabled' || $gDDL.attr('disabled') == 'true'))) {
                        //dana ddl jest wylaczone, wiec mozemy sprawdzic kolejna
                        continue;
                    } else {
                        let $sDDLSelectedIndices = $gDDL.valExtended()
                        let $menu = kdrDropdown.getTogglerMenu($gDDL)
                        if ($.isArray($sDDLSelectedIndices)) {

                            for (var l = 0; l < $sDDLSelectedIndices.length; l++) {
                                isAndGroupConditionMet = isAndGroupConditionMet && ($menu.find(`.kdr-dropdown-w-search-item[data-value="${$sDDLSelectedIndices[l]}"] [class*="da-ddl-${gIndex}"]`).length > 0
                                    || $menu.find(`.kdr-dropdown-w-search-item[data-value="${$sDDLSelectedIndices[l]}"] [class*="da-ddl-n"]`).length > 0)
                            }
                        } else {
                            isAndGroupConditionMet = isAndGroupConditionMet && ($menu.find(`.kdr-dropdown-w-search-item[data-value="${$sDDLSelectedIndices}"] [class*="da-ddl-${gIndex}"]`).length > 0
                                || $menu.find(`.kdr-dropdown-w-search-item[data-value="${$sDDLSelectedIndices}"] [class*="da-ddl-n"]`).length > 0)
                        }
                    }
                }
            } else {
                isAndGroupConditionMet = true
            }

            isEnablerSelected = isEveryOrGroupConditionMet && isAndGroupConditionMet


            if (isEnablerSelected) {
                $t.removeAttr('disabled')
            } else {
                $t.attr('disabled', 'disabled')

                $t.each((i, e) => {
                    let $e = $t.eq(i)
                    if ($e.hasClass('kdr-dropdown-w-search-input')) {
                        if ($e.closest('.kdr-dropdown-w-search_multi').length > 0) {
                            kdrDropdown.clearDropdown($e.closest('.kdr-dropdown-w-search'))
                        } else {
                            $e.valExtended(0)
                        }
                    }
                    else if ($e.hasClass('.custom-checkbox')) {
                        $e.valExtended(0)
                    } else {
                        $e.valExtended('')
                    }
                })


                //$t.filter((i, e) => $(e).closest('.kdr-dropdown-w-search_multi').length > 0).each((i, e) => {

                //})

                //$t.filter((i, e) => $(e).hasClass() && $(e).closest('.kdr-dropdown-w-search_multi').length == 0)
                //    .valExtended(0)

                //$t.filter((i, e) => $(e).closest('.custom-checkbox').length > 0)
                //    .valExtended(false)
            }

            disabler.changeVisibility($t, isEnablerSelected)
        }

        disabler.checkChildren($targets)
        disabler.manageTooltip($targets)

        if (triggerEvent) {
            disabler.triggerEvent($targets, disabler.events.ended)
        }
    },
    disableBasedOnMDDL($mddl, triggerEvent = true) {
        let dsPattern = /ds-mddl-(\S+)/i

        let groupIndex = $mddl.attr('class').match(dsPattern)[1]
        
        let $ddlMenu = kdrDropdown.getTogglerMenu($mddl)
        let $targets = $('[class*="dt-mddl-' + groupIndex + '"]')
        let isEnablerSelected =
            $mddl
                .valExtended()
                .some(x => $ddlMenu.find(`.kdr-dropdown-w-search-item[data-value="${x}"] [class*="da-mddl-${groupIndex}"]`).length > 0)
        if (isEnablerSelected) {
            $targets.removeAttr('disabled')
        } else {
            $targets.attr('disabled', 'disabled').valExtended([])

            $targets.filter((i, e) => $(e).closest('.custom-checkbox').length > 0)
                .valExtended(false)
        }

        disabler.checkChildren($targets)
        disabler.changeVisibility($targets, isEnablerSelected)
        disabler.manageTooltip($targets)
        if (triggerEvent) {
            disabler.triggerEvent($targets, disabler.events.ended)
        }
    },
    disableBasedOnRDDL($rddl, triggerEvent = true) {
        let dsPattern = /ds-rddl(?:-(\w+)){1}?(?:-(\S+))?/i;
        let groupIndex = $rddl.attr('class').match(dsPattern)[1]
        let isPerIndexStyle = $rddl.attr('class').match(dsPattern)[2] != undefined
        let $targets = $('[class*="dt-rddl-' + groupIndex + '"]'),
            $targetsToEnable = $(),
            $targetsToDisable = $()

        if (isPerIndexStyle === true) {
            let selectedIndex = $rddl.find('.kdr-custom-radio:checked').closest('.custom-radio').index()

            $targetsToEnable = $targets.filter((i, e) => $(e).hasClass(`dt-rddl-${groupIndex}-${selectedIndex}`))
            $targetsToDisable = $targets.filter((i, e) => !$(e).hasClass(`dt-rddl-${groupIndex}-${selectedIndex}`))
        } else {
            //all items style
            if ($rddl.find(`[class*="da-rddl-${groupIndex}"]`).length != 0) {
                $targetsToEnable = $targets.filter((i, e) => $(e).hasClass(`dt-rddl-${groupIndex}`))
            } else {
                $targetsToDisable = $targets.filter((i, e) => $(e).hasClass(`dt-rddl-${groupIndex}`))
            }
        }


        $targetsToEnable.removeAttr('disabled')
        $targetsToDisable.attr('disabled', 'disabled').valExtended('')

        disabler.checkChildren($targets)
        disabler.changeVisibility($targetsToDisable, false, () => disabler.changeVisibility($targetsToEnable, true))
        disabler.manageTooltip($targetsToDisable)

        if (triggerEvent) {
            disabler.triggerEvent($targets, disabler.events.ended)
        }
    },
}

$(document).on(`change ${disabler.events.disabler}`, '.kdr-grid-input[class*="ds-"][type="checkbox"], .custom-control-input[class*="ds-"][type="checkbox"]', function () {
    disabler.disableBasedOnCheckbox($(this))
})
$(document).on(`change ${disabler.events.disabler}`, '[class*="ds-ddl-"]', function () {
    disabler.disableBasedOnDDL($(this))
})
$(document).on(`change ${disabler.events.disabler}`, '[class*="ds-mddl-"]', function () {
    disabler.disableBasedOnMDDL($(this))
})
$(document).on(`change ${disabler.events.disabler}`, '.radio-buttons-wrapper[class*="ds-rddl-"]', function () {
    disabler.disableBasedOnRDDL($(this))
})

//#endregion